import QRCode from 'qrcode';

// คำแนะนำการสแกน: แสดงในหน้าต่าง QR และพิมพ์ลงในรูปที่ดาวน์โหลด
export const QR_HEADLINE = 'วิธีลงทะเบียนเข้าร่วมประชุม';
export const QR_STEPS = [
  'สแกน QR Code ด้วยกล้องโทรศัพท์',
  'แตะลิงก์ ระบบจะเปิดแอป ThaID ให้อัตโนมัติ',
  'ยืนยันตัวตนในแอป ThaID เป็นอันเสร็จ',
];
export const QR_NOTE = 'ต้องมีแอป ThaID ที่ลงทะเบียนใช้งานแล้ว';

const FONT = "'Sukhumvit Set', Tahoma, sans-serif";
const NAVY = '#0C2F53';
const GREY = '#5B6B7F';
// สระ/วรรณยุกต์ไทยที่ห้ามขึ้นต้นบรรทัดใหม่ (ต้องติดกับตัวอักษรก่อนหน้า)
const THAI_MARK = /[ัิ-ฺ็-๎]/;

// ตัดข้อความให้พอดีความกว้าง: ตัดที่ช่องว่างก่อน ถ้าคำยาวเกินจึงตัดทีละตัวอักษร (ไม่แยกสระ/วรรณยุกต์)
function wrapText(ctx, text, maxWidth) {
  const lines = [];
  let line = '';
  const push = piece => {
    const next = line + piece;
    if (ctx.measureText(next).width <= maxWidth || !line.trim()) {
      line = next;
    } else {
      lines.push(line.trim());
      line = piece.trimStart();
    }
  };
  text.split(/(\s+)/).forEach(word => {
    if (ctx.measureText(word).width <= maxWidth) {
      push(word);
      return;
    }
    let chunk = '';
    for (const ch of word) {
      if (chunk && !THAI_MARK.test(ch) && ctx.measureText(line + chunk + ch).width > maxWidth) {
        push(chunk);
        chunk = '';
      }
      chunk += ch;
    }
    push(chunk);
  });
  if (line.trim()) lines.push(line.trim());
  return lines;
}

async function loadFonts() {
  if (!document.fonts || !document.fonts.load) return;
  try {
    await Promise.all([
      document.fonts.load(`700 40px ${FONT}`),
      document.fonts.load(`400 26px ${FONT}`),
    ]);
  } catch (e) {
    // โหลดฟอนต์ไม่ได้ก็ใช้ฟอนต์สำรองแทน
  }
}

// สร้างรูป PNG: ชื่อการประชุม + QR + วิธีสแกน คืนค่าเป็น data URL
export async function buildQrPoster(link, title, headline = QR_HEADLINE) {
  await loadFonts();

  const W = 900;
  const PAD = 70;
  const TEXT_W = W - PAD * 2;
  const QR = 560;

  const qrCanvas = document.createElement('canvas');
  await QRCode.toCanvas(qrCanvas, link, { width: QR, margin: 1 });

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // วัดข้อความก่อนเพื่อคำนวณความสูงรูป
  ctx.font = `700 40px ${FONT}`;
  const titleLines = wrapText(ctx, title || 'QR Code ลงทะเบียน', TEXT_W);
  ctx.font = `400 26px ${FONT}`;
  const stepLines = QR_STEPS.map((s, i) => wrapText(ctx, `${i + 1}. ${s}`, TEXT_W - 20));
  const stepCount = stepLines.reduce((n, l) => n + l.length, 0);

  const H = PAD + titleLines.length * 54 + 20 + QR + 40 + 44 + stepCount * 40 + QR_STEPS.length * 8 + 30 + 36 + PAD;
  canvas.width = W;
  canvas.height = H;

  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = '#FFC600';
  ctx.fillRect(0, 0, W, 12);

  let y = PAD;
  ctx.textBaseline = 'top';
  ctx.textAlign = 'center';
  ctx.fillStyle = NAVY;
  ctx.font = `700 40px ${FONT}`;
  titleLines.forEach(l => { ctx.fillText(l, W / 2, y); y += 54; });

  y += 20;
  ctx.drawImage(qrCanvas, (W - QR) / 2, y, QR, QR);
  y += QR + 40;

  ctx.font = `700 30px ${FONT}`;
  ctx.fillText(headline, W / 2, y);
  y += 44;

  ctx.textAlign = 'left';
  ctx.fillStyle = '#2B3A4D';
  ctx.font = `400 26px ${FONT}`;
  stepLines.forEach(lines => {
    lines.forEach((l, i) => { ctx.fillText(l, PAD + (i ? 30 : 0), y); y += 40; });
    y += 8;
  });

  y += 30;
  ctx.textAlign = 'center';
  ctx.fillStyle = GREY;
  ctx.font = `400 22px ${FONT}`;
  ctx.fillText(`* ${QR_NOTE}`, W / 2, y);

  return canvas.toDataURL('image/png');
}

// ชื่อไฟล์จากชื่อการประชุม (ตัดอักขระที่ใช้เป็นชื่อไฟล์ไม่ได้)
export function qrFileName(title) {
  const safe = (title || '').replace(/[\\/:*?"<>|]/g, ' ').replace(/\s+/g, ' ').trim();
  return `QR-${safe || 'meeting'}.png`;
}

export async function downloadQrPoster(link, title, headline) {
  const a = document.createElement('a');
  a.href = await buildQrPoster(link, title, headline);
  a.download = qrFileName(title);
  a.click();
}
